//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, reduce } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
//////COMPONENTS//////
import Table from '../../components/Table'
import { LogUserManagerNested } from './Components'
import { logUsersActionCreators, usersManagerActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseDatePicker from '../../hooks/UseDatePicker'
import { TextModal, DatePickerFilterLabel } from '../../theme/GlobalCss'
import UseCheckAll from '../../hooks/UseCheckAll'
import urlExport from '../../constants/UrlExport'
import userPrivileges from '../../constants/PrivilegesList'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Calendar from '../../assets/icones/global/calendar.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const DatePickerTransactionIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	justify-content: end;
`
//////STYLED//////

const LogUsersManager = (props) => {
	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)
	const [filterIn, setFilterIn] = useState({})
	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'dateCreated', nameDir: 'desc' })

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modals
	const [showModalTicket, setShowModalTicket] = useState(false)

	const [stepSwitch, setStepSwitch] = useState(false)

	//Columns
	const [columns, setColumns] = useState([])

	const { user, translations, logUsers, logUsersFilters, userKioskPerimeter, userLogin, isSearchfieldUpdated, currentColumn, currentDir } =
		useSelector(
			(state) => ({
				translations: state.languages.translations,
				logUsers: state.logUsers,
				logUsersFilters: state.logUsers.header,
				user: state.user,
				userLogin: state.usersManager.userLogin,
				userKioskPerimeter: state.user.identity.kioskSelected,
				isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
				currentColumn: state.columns.currentColumn,
				currentDir: state.columns.currentDir,
			}),
			shallowEqual
		)
	const actionsLogUsers = bindActionCreators(logUsersActionCreators, useDispatch())
	const actionsUsersManager = bindActionCreators(usersManagerActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const [
		dateTransactionShowModal,
		dateTransactionOpenDateModalHandler,
		dateTransactionRenderModal,
		dateTransactionStateDate,
		setStartDate,
		setEndDate,
	] = UseDatePicker({
		defaultDateStart: moment().startOf('day').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).toDate(),
	})

	///////////////////////////////HANDLER ////////////////////////////////////////

	const handleModalTicket = (dataRow) => {
		setShowModalTicket((prevState) => !prevState)
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'dateCreated', nameDir: 'desc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsLogUsers.postLogUsers(handleFilterSend(), pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			datesRange: {
				dateStart: dateTransactionStateDate.date.startDate,
				dateEnd: dateTransactionStateDate.date.endDate,
			},
			searchField: filters.searchField?.length > 0 ? filters.searchField : '',
			...filtersOut,
		}
	}

	const handlePagingLogExtranet = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'dateCreated',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'desc',
			},
		}
		setPaging(pg)
		actionsLogUsers.postLogUsers(handleFilterSend(), pg)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			/* { dataHook: 'id', headerName: '', "isAuthorize": false, component: SalesHistoryToggleNested, sortable: false },*/
			{
				columnReferential: 'userLog_status',
				dataHook: 'status',
				headerName: translations['page__logAdmin__tableHeader_status'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'statusTranslationKey.id',
			},
			{
				columnReferential: 'userLog_logId',
				dataHook: 'idLog',
				headerName: translations['page__logAdmin__tableHeader_logId'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'id',
			},
			{
				columnReferential: 'userLog_dateHour',
				dataHook: 'date',
				headerName: translations['page__logAdmin__tableHeader_date'],
				sortable: true,
				isAuthorize: true,
				component: (props) => moment(props.row.date).format('DD/MM/YYYY HH:mm'),
				sortableId: 'dateCreated',
			},
			{
				columnReferential: 'userLog_createdBy',
				dataHook: 'userCreated',
				headerName: translations['page__logAdmin__tableHeader_createBy'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'createdBy.username',
			},
			{
				columnReferential: 'userLog_company',
				dataHook: 'company',
				headerName: translations['page__logAdmin__tableHeader_company'],
				sortable: true,
				isAuthorize: true,
				component: (props) => `${props.row.company} / ${translations[props.row.division]} `,
				sortableId: 'company.labelToDisplay',
			},
			{
				columnReferential: 'userLog_companyService',
				dataHook: 'service',
				headerName: translations['page__logAdmin__tableHeader_companyTyped'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'serviceCompany.label',
			},
			{
				columnReferential: 'userLog_store',
				dataHook: 'store',
				headerName: translations['page__logAdmin__tableHeader_store'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'storeCompany.labelToDisplay',
			},
			{
				columnReferential: 'userLog_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__logAdmin__tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'userLog_kioskName',
				dataHook: 'kioskName',
				headerName: translations['page__logAdmin__tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.description',
			},
			{
				columnReferential: 'userLog_clientKioskCode',
				dataHook: 'customerKioskCode',
				headerName: translations['page__logAdmin__tableHeader_customerKioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'kiosk.labelToOwner',
			},
			{
				columnReferential: 'userLog_category',
				dataHook: 'category',
				headerName: translations['page__logAdmin__tableHeader_category'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'categoryTranslationKey.id',
			},
			{
				columnReferential: 'userLog_subCategory',
				dataHook: 'subCategory',
				headerName: translations['page__logAdmin__tableHeader_subCategory'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'subCategoryTranslationKey.id',
			},
			{
				columnReferential: 'userLog_event',
				dataHook: 'event',
				headerName: translations['page__logAdmin__tableHeader_event'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'eventTranslationKey.id',
			},
			{
				columnReferential: 'userLog_canal',
				dataHook: 'canal',
				headerName: translations['page__logAdmin__tableHeader_canal'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'canalTranslationKey.id',
			},
			{
				columnReferential: 'userLog_level',
				dataHook: 'level',
				headerName: translations['page__logAdmin__tableHeader_level'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'levelTranslationKey.id',
			},
			{
				columnReferential: 'userLog_raisedBy',
				dataHook: 'userRaised',
				headerName: translations['page__logAdmin__tableHeader_raisedBy'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'raiser.username',
			},
			{
				columnReferential: 'userLog_fixedBy',
				dataHook: 'userFixed',
				headerName: translations['page__logAdmin__tableHeader_fixedBy'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'fixer.username',
			},
		])
	}, [translations])

	const tableReferential = {
		idPageTable: 16,
		labelPageTable: 'userLog',
	}

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},

			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['page__logAdmin__filters_date']} :
						</label>
						<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateTransactionStateDate.date.startDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateTransactionStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},
		paging: {
			fnSendTo: (paging) => handlePagingLogExtranet(paging),
		},
	})
	const [configTable, setConfigTable] = useState({
		nestedValues: {
			value: true,
			nestedData: 'message',
			nestedComponent: LogUserManagerNested,
			nestedPointer: 'idLog', // To retrieve index of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			nestedPointerValuePath: 'props.row.idLog', // To retrieve value of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			toggleAllNestedPointer: 'toggleNested', // Are we seeing nested lines or not
		},
	})

	///////////////////////////////USE EFFECT//////////////////////////////////////

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === logUsers || userLogin) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		if (dateTransactionStateDate.showModal) {
			actionsLogUsers.postLogUsers(handleFilterSend(), paging)
		}
	}, [dateTransactionShowModal])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		cfg.paging = {
			totalElements: logUsers.paging.totalElements,
			totalPages: logUsers.paging.totalPages,
			fnSendTo: (paging) => handlePagingLogExtranet(paging),
		}
		setConfigTableTitle(cfg)
		//setInputData(logUsers.items)
	}, [logUsers])

	useEffect(() => {
		const filtersCp = cloneDeep(logUsersFilters)
		// According to feat 151 we have to send the traduction for the back statement
		// however we have to apply translation to the filter view
		// we comment this code and we do  translation directly from PaperList component
		/* 	// Division filters is a translation composed with a traduction key inside
			// So we need to revamp it
			if (!isUndefined(filtersCp.filtersSelection)) {
				filtersCp.filtersSelection.division.filterElements.map((elem) => {
					let parseLabel = elem.label.split(' / ')
					parseLabel[1] = translations[parseLabel[1]]
					const s = parseLabel.join(' / ')
					elem.label = s
	
					return elem
				})
			}
			setFilterIn(logUsersFilters) */
		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [logUsersFilters, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks)) {
			actionsLogUsers.postLogUsers(handleFilterSend(), paging)
		}
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		const filtersCp = cloneDeep(filters) // add fot he new filters method
		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__logAdmin__user__title']
		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__logAdmin__filters_date']} :
					</label>
					<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]
		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__logAdmin__filters_company']}
					data={filtersCp.filtersSelection?.division.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					submitOnClose={handleSubmit}
					selectActionsHandler={handleCheckElements}
					target={'division'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__logAdmin__filters_createBy']}
					data={filtersCp.filtersSelection?.user.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'user'}
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__logAdmin__filters_status']}
					data={filtersCp.filtersSelection?.status.filterElements || []}
					toTranslate={true}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'status'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__logAdmin__filters_level']}
					data={filtersCp.filtersSelection?.level.filterElements || []}
					toTranslate={true}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'level'}
				/>
			),
		]

		cfg.paging = {
			totalElements: logUsers.paging.totalElements,
			totalPages: logUsers.paging.totalPages,
			fnSendTo: (paging) => handlePagingLogExtranet(paging),
		}

		setConfigTableTitle(cfg)
	}, [translations, filters, dateTransactionStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[12],
			url: urlExport[11],
			bd: {
				filtersSelection: filters.filtersSelection,
				withFilters: true,
				searchField: searchValue,
				datesRange: { dateEnd: dateTransactionStateDate.date.endDate, dateStart: dateTransactionStateDate.date.startDate },
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}

		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setStepSwitch(true)
		}
	}, [user, searchValue])

	const [test, setTest] = useState(false)

	useEffect(() => {
		if (userLogin) {
			setTest(true)
			setSearchValue(userLogin)
			actionsUsersManager.setUserLogin('')
		}

		return function cleanUp() {
			actionsLogUsers.resetLogUsers()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (stepSwitch) {
			let state_date = {}
			if (test) {
				state_date.startDate = moment().subtract(2, 'year').toDate()
				state_date.endDate = moment().toDate()
				setStartDate(moment(state_date.startDate).toDate())
				setEndDate(moment(state_date.endDate).toDate())
				setTest(false)
			} else {
				state_date.startDate = moment().startOf('day').toDate()
				state_date.endDate = moment().hours(23).minutes(59).toDate()
				setStartDate(moment(state_date.startDate).toDate())
				setEndDate(moment(state_date.endDate).toDate())
			}

			const filtersCp = {
				withFilters: false,
				searchFieldUpdated: searchValue?.length > 0 ? true : false,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				searchField: searchValue || null,
				datesRange: {
					dateStart: state_date.startDate,
					dateEnd: state_date.endDate,
				},
				filtersSelection: null,
			}
			actionsLogUsers.postLogUsers(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [stepSwitch, translations])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={logUsers.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={logUsers.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsLogUsers.postLogUsers}
			/>
		)
	}, [logUsers, columns, configTable, translations, paging])

	return (
		<Fragment>
			{dateTransactionRenderModal()}
			<Modals
				title={translations['modal__transactionsHistory__admin__title__sendMerchantTicket']}
				closeModalHandler={handleModalTicket}
				showModal={showModalTicket}
				icon={true}
			>
				<TextModal>
					<p>{translations['modal__transactionsHistory__admin__body__sendMerchantTicket']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						//actionHandler={ handleModalTicket }
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
					/>
					<Button
						//actionHandler={ () => {handleTicketAsk()} }
						text={translations['modal_transactionsHistory__admin__validation']}
						bgColor={Theme.colors.validation}
					/>
				</ButtonWrapper>
			</Modals>
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

LogUsersManager.propTypes = {}

LogUsersManager.defaultPropTypes = {}

export default LogUsersManager
